import { FC } from 'react'
import { match } from 'ts-pattern'
import { Fix } from '../../utils/api-client/api-schemas'
import * as styles from './fix-strategy-tag.css'

interface FixStrategyTagProps {
  strategy: Fix['strategy']
}

export const FixStrategyTag: FC<FixStrategyTagProps> = ({ strategy }) => {
  const tag = match(strategy)
    .with('deterministic', () => (
      <span role="status" aria-label="Deterministic fix" className={styles.aiAndDeterministicBadge}>
        Deterministic
      </span>
    ))
    .with('ai', () => (
      <span role="status" aria-label="AI generated fix" className={styles.aiAndDeterministicBadge}>
        AI
      </span>
    ))
    .with('hybrid', () => (
      <span role="status" aria-label="AI generated fix" className={styles.aiAndDeterministicBadge}>
        Hybrid
      </span>
    ))
    .with('provisional_ai', () => (
      <span role="status" aria-label="AI generated fix" className={styles.aiAndDeterministicBadge}>
        AI
      </span>
    ))
    .exhaustive()

  return (
    <div role="group" aria-label="Fix strategy" className={styles.fixTypeIndicators}>
      {tag}
    </div>
  )
}
